import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';

// Масштаб экрана (пикселей экрана на CSS px) — для толщины линий срезов: styles.css
// округляет её до целых пикселей экрана (--lw). Меняется при зуме браузера и при
// переносе окна на другой монитор; matchMedia срабатывает один раз — перевешиваем.
// Сбой здесь не должен ронять админку: без --dpr линии просто остаются по 1 CSS px.
function syncDevicePixelRatio() {
  const dpr = window.devicePixelRatio || 1;
  document.documentElement.style.setProperty('--dpr', String(dpr));
  try {
    const mql = window.matchMedia(`(resolution: ${dpr}dppx)`);
    const onChange = () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange);
      else mql.removeListener(onChange);  // Safari < 14
      syncDevicePixelRatio();
    };
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else mql.addListener(onChange);
  } catch (e) { /* нет matchMedia — масштаб не отслеживаем */ }
}
syncDevicePixelRatio();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);



